import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Product } from '../interfaces';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  url: string = environment.base_url;

  constructor(private _http: HttpClient) { }

  profile() {
    return this._http.get(this.url + '/api/user/profile', {
      observe: 'body',
      withCredentials: true,
      headers: new HttpHeaders().append('Content-Type', 'application/json')
    })
  }

  editProduct(id: number, product: Product){
    return this._http.post(this.url + `/api/product/${id}/edit`, product, {
      observe: 'body',
      withCredentials: true,
      headers: new HttpHeaders().append('Content-Type', 'application/json')
    })
  }

  deleteProduct(id: number){
    return this._http.get(this.url + `/api/product/${id}/delete`, {
      observe: 'body',
      withCredentials: true,
      headers: new HttpHeaders().append('Content-Type', 'application/json')
    })
  }

  fetchProduct(){
    return this._http.get(this.url + '/api/product/my/0/all', {
      observe: 'body',
      withCredentials: true,
      headers: new HttpHeaders().append('Content-Type', 'application/json')
    })
  }

  submitProduct(details: Product) {
    return this._http.post(this.url + '/api/product/new', details, {
      observe: 'body',
      withCredentials: true,
      headers: new HttpHeaders().append('Content-Type', 'application/json')
    });
  }

}
